<template>
  <main class="dn-margin-1" @click="tt">
    <div id="div-1" class="mx-auto dn-image-rem rounded" v-for="(item, index) in pj" :key="index">
      <img class="card-img-top" :src=item.pjsrc >
      <div class="row-2" style="padding-top: 1rem;">
        <pre class="dn-font-14" v-on:click="showmodalF">{{item.pjms}}</pre>
      </div>
    </div>

    <div class="modal" v-show="showModal">
      <div class="modal-dialog" style="width:900px;height:300px;">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="videoPlay">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
            <div class="modal-body" style="height:300px;">
              <video id="video"
              ref="dnvideo"
              class="dn-video-wh object-fit-contain video"
              :src="videoSrc"
              loop="loop"
              autoplay
              playsinline="true"
              controls="controls"
              x5-video-player-type="h5"
              x5-video-orientation="landscape"
              controlsList="nodownload  noplaybackrate"
              disablePictureInPicture
              v-bind:style="{width: width + 'px'}">
              </video>
            </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'model3',
  data () {
    return {
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      toPage: this.$route.query.toPage,
      // model
      showModal: false,
      videoSrc: '',
      // 获取page-config
      pageConfig: '',
      canclick: false
    }
  },
  methods: {
    showmodalF: function (event) {
      if (this.videoSrc !== undefined) {
        this.showModal = true
        this.canclick = true
        this.$refs.dnvideo.play()
      }
    },
    videoPlay: function (event) {
      this.showModal = false
      if (this.$refs.dnvideo.paused) {
        // nothing to do
      } else {
        this.$refs.dnvideo.pause()
      }
    },
    tt: function () {
      if (this.videoSrc !== undefined && this.canclick === true) {
        // this.showModal = false
      }
    }
  },
  mounted () {
    // 页面高度 宽度变化
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        this.height = window.screenHeight

        window.screenWidth = document.body.clientWidth
        this.width = window.screenWidth
      })()
    }
  },
  watch: {
    toPage: {
      handler: function (newValue, oldValue) {
        if (newValue !== undefined) {
          this.pageConfig = this.$global.filter(item => item.page === newValue)[0]
          this.pj = this.pageConfig.pj
          this.videoSrc = this.pj[0].tzvideosrc
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped>

.dn-image-rem {
    width: 22rem;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem;
}

.modal {
  position: fixed;
  top: -10rem;
  left: 0;
  width: 100%!;
  height: 100%!;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/model3.vue